export default __webpack_public_path__ + "static/pack_mobile_en-db19e180d2e99de5e03f4dc0d2f75db7.png";